module.exports = __webpack_public_path__ + "static/media/ig.bb07b0ad.svg";